import React from "react";
import { useNavigate } from "react-router-dom";
import "./Itinerary.css";
import kitulgalaImg from "./adventure.jpg";
import ellaImg from "./hill.png";
import arugamBayImg from "./aru.png";
import yalaImg from "./safari.jpg";
import bentotaImg from "./bentota.png";
import { useTranslation } from "./hooks/useTranslation";

const Package5Details = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBookNow = () => {
    navigate("/buy");
  };

  const packageInfo = {
    duration: t.package5Duration,
    charges: t.package5Charges,
    hotel: t.package5Hotel,
    price: t.package5Price
  };

  const locationsData = t.package5Locations || [];

  const locationImages = [
    { image: kitulgalaImg, alt: "Kitulgala" },
    { image: ellaImg, alt: "Ella" },
    { image: arugamBayImg, alt: "Arugam Bay" },
    { image: yalaImg, alt: "Yala" },
    { image: bentotaImg, alt: "Bentota" }
  ];

  return (
    <div className="itinerary-wrapper">
      <header className="itinerary-header">
        <h1>{t.package5Title}</h1>
        <div className="package-info-section">
          <p className="intro-text">
            <strong>{packageInfo.duration}</strong>
          </p>
          <p className="intro-text">{packageInfo.charges}</p>
          <p className="intro-text">{packageInfo.hotel}</p>
          <p className="intro-text">
            <strong style={{ color: "#1a73e8", fontSize: "1.2rem" }}>
              {packageInfo.price}
            </strong>
          </p>
        </div>
      </header>

      {/* Book Now button above itinerary, right aligned */}
      <div className="book-now-wrapper top-right">
        <button className="book-now-button" onClick={handleBookNow}>
          {t.bookNow}
        </button>
      </div>

      <div className="itinerary-cards-container">
        {locationsData.map((location, index) => {
          const imageObj = locationImages[index] || {};
          return (
            <div key={index} className="itinerary-card">
              <div className="card-header">
                <div className="day-badge">{location.name}</div>
              </div>

              <div className="card-content">
                {imageObj.image && (
                  <img 
                    src={imageObj.image} 
                    alt={imageObj.alt || location.name} 
                    className="activity-image"
                  />
                )}
                <h3>{t.package5Activities}</h3>
                <div className="activity-details">
                  {location.activities.map((activity, i) => (
                    <div key={i} className="activity-item">
                      <h4 className="activity-title">{activity.title}</h4>
                      <p className="activity-desc">{activity.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Package5Details;
